import { jsx as _jsx } from "react/jsx-runtime";
import { SubstructureDefault } from "./SubstructureDefault";
import { SubstructureEmbedded } from "./SubstructureEmbedded";
import { SubstructureEmbeddedContent } from "./SubstructureEmbeddedContent";
import { SubstructureVariant, } from "./SubstructureLayout";
import { SubstructureStub } from "./SubstructureStub";
import { useSubstructureLayout } from "./useSubstructureLayout";
const substructureVariants = {
    [SubstructureVariant.Embedded]: SubstructureEmbedded,
    [SubstructureVariant.Default]: SubstructureEmbedded,
    [SubstructureVariant.Stub]: SubstructureStub,
    [SubstructureVariant.Content]: SubstructureEmbeddedContent,
};
export function Substructure(_props) {
    var _a;
    const { variant } = useSubstructureLayout();
    const VariantComponent = (_a = substructureVariants[variant]) !== null && _a !== void 0 ? _a : SubstructureDefault;
    return _jsx(VariantComponent, {});
}
Substructure.displayName = "Substructure";
//# sourceMappingURL=Substructure.js.map